import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import './LieDetectorDot.css';
import api from '../api';

const LieDetectorDot = () => {
  const { token } = useContext(AuthContext);
  const [hasPending, setHasPending] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    let interval;
    const checkPending = async () => {
      try {
        const res = await api.get('/inquisition/pending');
        setHasPending(res.data.hasPending);
      } catch (e) {
        console.error('[LieDetector] check pending failed:', e);
      }
    };

    if (token) {
      checkPending();
      interval = setInterval(checkPending, 30000); // Check every 30s

      const handleForceCheck = () => {
        checkPending();
      };
      window.addEventListener('inquisition-read-all', handleForceCheck);

      return () => {
        if (interval) clearInterval(interval);
        window.removeEventListener('inquisition-read-all', handleForceCheck);
      };
    }
  }, [token]);

  return (
    <div
      className={`lie-detector-dot ${hasPending ? 'status-pending' : 'status-stable'}`}
      onClick={(e) => {
        e.stopPropagation(); // Prevent bubbling to header-center which navigates to /
        navigate('/inquisition');
      }}
      title="Anomaly Detected: Inquisition required"
    ></div>
  );
};

export default LieDetectorDot;
